<div class="tro">
	<div class="tro-head">
		<div class="tro-title">
			<img src="assets/LogoFlat_White.png" alt="BPL" />
			<div>
				<span class="eyebrow">Live board</span>
				<h1>Toolroom</h1>
			</div>
		</div>

		<div class="tro-summary">
			<div class="pill tone-go"><b>{{ summary.running }}</b><span>Running</span></div>
			<div class="pill tone-setup"><b>{{ summary.settingUp }}</b><span>Setting up</span></div>
			<div class="pill tone-idle"><b>{{ summary.idle }}</b><span>Idle</span></div>
			<div class="pill tone-danger" [class.muted]="summary.down === 0"><b>{{ summary.down }}</b><span>Down</span></div>
			<div class="pill tone-alert" [class.muted]="summary.supervisor === 0" [class.pulse]="summary.supervisor > 0"><b>{{ summary.supervisor }}</b><span>Supervisor</span></div>
		</div>

		<div class="tro-clock">
			<b>{{ now | date: 'HH:mm' }}</b>
			<span>{{ now | date: 'EEE d MMM' }}</span>
			<small [class.stale]="error">{{ error || ('Updated ' + (lastRefresh | date: 'HH:mm:ss')) }}</small>
		</div>
	</div>

	<toolroom-loader *ngIf="isLoading" text="Loading the toolroom" variant="draw"></toolroom-loader>

	<div class="tro-grid">
		<div *ngFor="let card of cards; trackBy: trackMachine" class="mc" [ngClass]="'tone-' + card.status.tone" [class.has-job]="card.job">
			<div class="mc-bar"></div>

			<div class="mc-body">
				<div class="mc-head">
					<div class="mc-name">
						<b>{{ card.machine.cellNumber }}</b>
						<span>{{ card.machine.machineName }}</span>
					</div>
					<span class="mc-status"><i></i>{{ card.status.label }}</span>
				</div>

				<div *ngIf="card.machine.openRequest" class="mc-request">
					🙋 Supervisor{{ card.machine.openRequest.reason ? ' - ' + card.machine.openRequest.reason : '' }}
					<small>{{ card.requestAge }}</small>
				</div>

				<ng-container *ngIf="card.job; else idle">
					<div class="mc-job">
						<div class="mc-thumb">
							<img *ngIf="card.billetImage" [src]="card.billetImage" alt="" (error)="card.billetImage = ''" />
							<span *ngIf="!card.billetImage">▣</span>
						</div>
						<div class="mc-job-main">
							<h2>{{ card.job.billetName }}</h2>
							<span class="op">OP{{ card.job.opNumber }}{{ card.job.processDescription ? ' · ' + card.job.processDescription : '' }}</span>
							<div class="mc-facts">
								<span><em>Tool</em>{{ card.job.toolName || '—' }}</span>
								<span><em>Program</em>{{ card.job.programId ? '#' + (card.job.programId + '').padStart(4, '0') : '—' }}</span>
								<span><em>Operator</em>{{ card.job.operatorName || '—' }}</span>
							</div>
						</div>
					</div>

					<div *ngIf="card.progress; else noPlan" class="mc-progress" [class.paused]="card.job.isPaused" [class.over]="card.progress.overrun">
						<div class="mc-times">
							<div>
								<em>{{ card.job.isPaused ? 'Paused' : card.progress.overrun ? 'Over' : 'Time left' }}</em>
								<b>{{ card.progress.overrun ? '+' + minutes(card.progress.elapsedMinutes - card.progress.totalMinutes) : (minutes(card.progress.remainingMinutes) || '0m') }}</b>
							</div>
							<div class="right">
								<em>Planned finish</em>
								<b class="finish">{{ card.finish | date: 'HH:mm' }}<small *ngIf="card.finishOtherDay"> {{ card.finish | date: 'EEE' }}</small></b>
							</div>
						</div>
						<div class="bar">
							<i *ngFor="let seg of card.progress.segments" class="seg" [class.now]="seg.index === card.progress.currentIndex"
								[style.left.%]="seg.startPercent" [style.width.%]="seg.widthPercent"></i>
							<div class="fill" [style.width.%]="card.progress.percent"></div>
							<div class="marker" [style.left.%]="card.progress.percent"></div>
						</div>
						<div *ngIf="card.cutter" class="mc-cutter">
							<span class="seq">{{ card.progress.currentIndex + 1 }}</span>
							<div>
								<em>Should be cutting</em>
								<b>{{ card.cutterLabel }}</b>
							</div>
							<span class="of">{{ card.progress.currentIndex + 1 }}/{{ card.job.cutters.length }}</span>
						</div>
					</div>
					<ng-template #noPlan>
						<div class="mc-noplan" *ngIf="card.job.isSettingUp; else noRunTimes">Setting up {{ card.settingUpFor || 'just started' }}</div>
						<ng-template #noRunTimes>
							<div class="mc-noplan">Running {{ card.runningFor || 'just started' }} · no run times on the program</div>
						</ng-template>
					</ng-template>
				</ng-container>

				<ng-template #idle>
					<div class="mc-idle">
						<span>{{ card.machine.next ? 'Nothing running' : 'Queue empty' }}</span>
						<b *ngIf="card.machine.next">Next: {{ card.machine.next.toolName ? card.machine.next.toolName + ' - ' : '' }}{{ card.machine.next.billetName }} · OP{{ card.machine.next.opNumber }}</b>
					</div>
				</ng-template>

				<div class="mc-foot" *ngIf="card.machine.queueCount > 0">
					<span *ngIf="card.job && card.machine.next" class="next">Next: <b>{{ card.machine.next.toolName ? card.machine.next.toolName + ' - ' : '' }}{{ card.machine.next.billetName }}</b></span>
					<span class="count">{{ card.machine.queueCount }} queued</span>
				</div>
			</div>
		</div>

		<div *ngIf="!isLoading && cards.length === 0" class="tro-empty">{{ error ? "Couldn't load the toolroom board - " + error : "No toolroom machines found for this site." }}</div>
	</div>
</div>
